export const reloadWindow = () => {
  // oxlint-disable-next-line no-restricted-properties
  window.location.reload();
};
